/*
 * @Description:
 * @Author: seam
 * @Date: 2021-08-10 14:50:10
 * @LastEditors: seam
 * @LastEditTime: 2021-08-19 14:15:45
 * @FilePath: \mgmt-client\src\api\tm.js
 */
import request from '@/libs/request'
/**
 *近似查询
 * @export
 * @param {*} form
 * @returns
 */
export function query_similar(form) {
  return request({
    url: 'v6/search/similar',
    data: form
  })
}
/**
 *综合查询
 * @export
 * @param {*} data
 * @returns
 */
export function query_colligate(data) {
  return request({
    url: 'v6/search/comprehensiveQuery',
    data: data
  })
}
/**
 * 获取商标公告图片
 * @param {*} params
 */
export function get_AnnounceImg(params) {
  return request({
    url: 'v6/search/getAnnounceImgByIds',
    data: params,
    method: 'post'
  })
}
/** 获取商标详情 */
export function get_TmDetail(params) {
  return request({
    url: 'v6/search/tmdetails',
    data: params,
    method: 'post'
  })
}
/**
 * 申请人或代理人自动补全
 * @param {*} data
 */
export function completionName(data) {
  return request({
    url: 'v6/search/completionName',
    method: 'post',
    data: data
  })
}
/**
 * 查询报告
 * @param {*} params
 */
export function get_trail(params) {
  return request({
    url: 'v6/search/getTrialList',
    data: params,
    method: 'post'
  })
}
/**
 * 批量获取商标详情
 * @param {*} idsArr
 * @returns
 */
export function get_tmlist(idsArr) {
  return request({
    url: 'v6/search/tmdetails',
    data: {
      idsArr,
      fields: [
        'sbmc',
        'intcls',
        'regno',
        'tmstatus',
        'trialnum',
        'trialdate',
        'appdate',
        'regnum',
        'tmapplicant'
      ]
    },
    method: 'post'
  })
}
/**
 * @description 查询商标分类书1级
 * @export
 */
export function get_tmType1(intcls = null) {
  return request({
    url: 'v6/search/tmType1',
    method: 'post',
    data: { intcls }
  })
}
/**
 * @description 查询商标分类书2级
 * @export
 */
export function get_tmType2(data) {
  return request({
    url: 'v6/search/tmType2',
    method: 'post',
    data: data
  })
}
/**
 * 搜索商品
 * @param {*} data
 * @returns
 */
export function search_goodss(data) {
  return request({
    url: 'v4/search/searchGoodss',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/tm.js